import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sidebar-nav" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SidebarNavItem = _resolveComponent("SidebarNavItem")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createVNode(_component_SidebarNavItem, {
      to: "/cdr-test/dashboard",
      icon: "experiment",
      title: "CDR Test Suite"
    })
  ]))
}